/* global document store */

import gsap from 'gsap';
import {
  SWITCH_BUTTON_CLASS,
  EXPAND_BUTTON_CLASS,
  LAUNCH_LIGHTBOX_BUTTON_CLASS,
  CLOSE_EXPAND_BUTTON_CLASS,
  SHOW_COMPONENT_BUTTON_CLASS,
  HIDE_COMPONENT_BUTTON_CLASS,
  SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  CAROUSEL_GROUP_BUTTON_CLASS,
  TIMELINE_BUTTON_CLASS,
  PLAY_VIDEO_BUTTON_CLASS,
  REPLAY_VIDEO_BUTTON_CLASS,
  PAUSE_VIDEO_BUTTON_CLASS,
  MUTE_VIDEO_BUTTON_CLASS,
  UNMUTE_VIDEO_BUTTON_CLASS,
  SWIPEGALLERY_BUTTON_CLASS,
  MOUSEOVER_SHOW_COMPONENT_BUTTON_CLASS,
  MOUSEOVER_HIDE_COMPONENT_BUTTON_CLASS,
  MOUSEOVER_SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  MOUSEOVER_HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  MOUSEOUT_SHOW_COMPONENT_BUTTON_CLASS,
  MOUSEOUT_HIDE_COMPONENT_BUTTON_CLASS,
  MOUSEOUT_SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  MOUSEOUT_HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPELEFT_CAROUSEL_GROUP_BUTTON_CLASS,
  SWIPELEFT_SWITCH_BUTTON_CLASS,
  SWIPELEFT_SHOW_COMPONENT_BUTTON_CLASS,
  SWIPELEFT_HIDE_COMPONENT_BUTTON_CLASS,
  SWIPELEFT_SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPELEFT_HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPELEFT_PLAY_VIDEO_BUTTON_CLASS,
  SWIPELEFT_REPLAY_VIDEO_BUTTON_CLASS,
  SWIPELEFT_PAUSE_VIDEO_BUTTON_CLASS,
  SWIPELEFT_MUTE_VIDEO_BUTTON_CLASS,
  SWIPELEFT_UNMUTE_VIDEO_BUTTON_CLASS,
  SWIPERIGHT_CAROUSEL_GROUP_BUTTON_CLASS,
  SWIPERIGHT_SWITCH_BUTTON_CLASS,
  SWIPERIGHT_SHOW_COMPONENT_BUTTON_CLASS,
  SWIPERIGHT_HIDE_COMPONENT_BUTTON_CLASS,
  SWIPERIGHT_SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPERIGHT_HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPERIGHT_PLAY_VIDEO_BUTTON_CLASS,
  SWIPERIGHT_REPLAY_VIDEO_BUTTON_CLASS,
  SWIPERIGHT_PAUSE_VIDEO_BUTTON_CLASS,
  SWIPERIGHT_MUTE_VIDEO_BUTTON_CLASS,
  SWIPERIGHT_UNMUTE_VIDEO_BUTTON_CLASS,
  SWIPEUP_CAROUSEL_GROUP_BUTTON_CLASS,
  SWIPEUP_SWITCH_BUTTON_CLASS,
  SWIPEUP_SHOW_COMPONENT_BUTTON_CLASS,
  SWIPEUP_HIDE_COMPONENT_BUTTON_CLASS,
  SWIPEUP_SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPEUP_HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPEUP_PLAY_VIDEO_BUTTON_CLASS,
  SWIPEUP_REPLAY_VIDEO_BUTTON_CLASS,
  SWIPEUP_PAUSE_VIDEO_BUTTON_CLASS,
  SWIPEUP_MUTE_VIDEO_BUTTON_CLASS,
  SWIPEUP_UNMUTE_VIDEO_BUTTON_CLASS,
  SWIPEDOWN_CAROUSEL_GROUP_BUTTON_CLASS,
  SWIPEDOWN_SWITCH_BUTTON_CLASS,
  SWIPEDOWN_SHOW_COMPONENT_BUTTON_CLASS,
  SWIPEDOWN_HIDE_COMPONENT_BUTTON_CLASS,
  SWIPEDOWN_SHOW_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPEDOWN_HIDE_REMOTE_COMPONENT_BUTTON_CLASS,
  SWIPEDOWN_PLAY_VIDEO_BUTTON_CLASS,
  SWIPEDOWN_REPLAY_VIDEO_BUTTON_CLASS,
  SWIPEDOWN_PAUSE_VIDEO_BUTTON_CLASS,
  SWIPEDOWN_MUTE_VIDEO_BUTTON_CLASS,
  SWIPEDOWN_UNMUTE_VIDEO_BUTTON_CLASS,
} from 'Tracking/constants/selectors';
import { getClosest } from 'Tracking/utils';
import {
  animateTransition,
  getContextElement,
  handleExpand,
  handleClose,
  handleLaunchLightbox,
  handleSwitchArtboard,
  handleShowComponent,
  handleHideComponent,
  handleShowRemoteComponent,
  handleHideRemoteComponent,
  handleChangeVisibiity,
  handleChangeVisibiityGlobal,
  handleButtonControlTimeline,
  handleScroll,
  handlePlayVideo,
  handleReplayVideo,
  handlePauseVideo,
  handleMuteVideo,
  handleUnmuteVideo,
  handleControlSwipeGallery,
  handleMouseOverShowComponent,
  handleMouseOverHideComponent,
  handleMouseOverShowRemoteComponent,
  handleMouseOverHideRemoteComponent,
  handleMouseOutShowRemoteComponent,
  handleMouseOutHideRemoteComponent,
  handleSwipeLeftSwitchArtboard,
  handleSwipeRightSwitchArtboard,
  handleSwipeUpSwitchArtboard,
  handleSwipeDownSwitchArtboard,
  handleSwipeLeftShowComponent,
  handleSwipeRightShowComponent,
  handleSwipeUpShowComponent,
  handleSwipeDownShowComponent,
  handleSwipeLeftHideComponent,
  handleSwipeRightHideComponent,
  handleSwipeUpHideComponent,
  handleSwipeDownHideComponent,
  handleSwipeLeftShowRemoteComponent,
  handleSwipeRightShowRemoteComponent,
  handleSwipeUpShowRemoteComponent,
  handleSwipeDownShowRemoteComponent,
  handleSwipeLeftHideRemoteComponent,
  handleSwipeRightHideRemoteComponent,
  handleSwipeUpHideRemoteComponent,
  handleSwipeDownHideRemoteComponent,
  handleMouseOutShowComponent,
  handleMouseOutHideComponent,
  handleSwipeLeftCarousel,
  handleSwipeRightCarousel,
  handleSwipeUpCarousel,
  handleSwipeDownCarousel,
  handleSwipeLeftPlayVideo,
  handleSwipeLeftReplayVideo,
  handleSwipeLeftPauseVideo,
  handleSwipeLeftMuteVideo,
  handleSwipeLeftUnmuteVideo,
  handleSwipeRightPlayVideo,
  handleSwipeRightReplayVideo,
  handleSwipeRightPauseVideo,
  handleSwipeRightMuteVideo,
  handleSwipeRightUnmuteVideo,
  handleSwipeUpPlayVideo,
  handleSwipeUpReplayVideo,
  handleSwipeUpPauseVideo,
  handleSwipeUpMuteVideo,
  handleSwipeUpUnmuteVideo,
  handleSwipeDownPlayVideo,
  handleSwipeDownReplayVideo,
  handleSwipeDownPauseVideo,
  handleSwipeDownMuteVideo,
  handleSwipeDownUnmuteVideo,
} from 'Renderer/domOperations/actionOperations';

import { setTargetComponentTimeline } from 'Renderer/domOperations/animationOperations';
import { initSwipeGestures } from 'Renderer/utils/customEvents';

const clickEvt = 'clicked';
const mouseOverEvt = 'mouseover';
const mouseOutEvt = 'mouseout';
const swipeLeftEvt = 'swiped-left';
const swipeRightEvt = 'swiped-right';
const swipeUpEvt = 'swiped-up';
const swipeDownEvt = 'swiped-down';

const getComponentContainer = (evt) => {
  const { rootElement } = store.getState(); // eslint-disable-line no-undef
  return getClosest(evt.target, 'div[data-artboard]') || rootElement;
};

const getComonentArtboard = (evt) => {
  const { rootElement, activeArtboard, artboards } = store.getState(); // eslint-disable-line no-undef
  const componentContainer = evt.target ? getClosest(evt.target, 'div[data-artboard]') || null : rootElement;
  const componentArtboardName = componentContainer ? componentContainer.getAttribute('data-artboard') || null : null;
  return componentArtboardName ? artboards.find(a => a.name === componentArtboardName) : activeArtboard;
};

export const showButtonSet = (component, action) => {
  const contextElement = getContextElement(component);
  const imageComponent = component.getAttribute(`data-video-${action}-image`);
  const imageElement = contextElement.querySelector(`.${imageComponent}`);
  if (!imageElement) return;
  imageElement.style.display = 'block';
  setTimeout(() => {
    component.style.display = 'block';
  }, 100);
};

export const hideButtonSet = (component, action) => {
  const contextElement = getContextElement(component);
  const imageComponent = component.getAttribute(`data-video-${action}-image`);
  const imageElement = contextElement.querySelector(`.${imageComponent}`);
  if (!imageElement) return;
  imageElement.style.display = 'none';
  setTimeout(() => {
    component.style.display = 'none';
  }, 100);
};

const initialiseEvent = (elem, evt, handler) => {
  elem.removeEventListener(evt, handler);
  elem.addEventListener(evt, handler);
};

const initialiseShowComponent = (elem, evt, handler) => {
  const { rootElement } = store.getState(); // eslint-disable-line no-undef
  const evtPrefix = (evt === clickEvt) ? 'data' : `data-${evt}`;
  const targetComponent = elem.getAttribute(`${evtPrefix}-show-target`);
  const componentObject = rootElement.querySelector(`.${targetComponent}`);
  setTargetComponentTimeline(componentObject);
  initialiseEvent(elem, evt, handler);
};

const checkCustomGestures = () => {
  if (typeof window['ivo-custom-gestures'] === 'undefined') {
    window['ivo-custom-gestures'] = true;
    initSwipeGestures();
  }
};

const getElements = (elemClass) => {
  const { rootElement } = store.getState(); // eslint-disable-line no-undef
  return rootElement.querySelectorAll(`.${elemClass}`);
};

export const createButtonEvents = (rootElement) => {
  checkCustomGestures();

  // expand
  [...rootElement.querySelectorAll(`.${EXPAND_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleExpand));
  [...rootElement.querySelectorAll(`.${CLOSE_EXPAND_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleClose));
  // switch artboard
  [...rootElement.querySelectorAll(`.${SWITCH_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleSwitchArtboard));
  // overlay
  [...rootElement.querySelectorAll(`.${LAUNCH_LIGHTBOX_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleLaunchLightbox));
  // show & hide components
  [...rootElement.querySelectorAll(`.${HIDE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleHideComponent));
  [...rootElement.querySelectorAll(`.${SHOW_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseShowComponent(btn, clickEvt, handleShowComponent));
  [...rootElement.querySelectorAll(`.${HIDE_REMOTE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleHideRemoteComponent));
  [...rootElement.querySelectorAll(`.${SHOW_REMOTE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleShowRemoteComponent));
  // Scroll
  [...rootElement.querySelectorAll(`.${CAROUSEL_GROUP_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleScroll));
  [...rootElement.querySelectorAll(`.${TIMELINE_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleButtonControlTimeline));

  // video
  [...rootElement.querySelectorAll(`.${PLAY_VIDEO_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handlePlayVideo));
  [...rootElement.querySelectorAll(`.${REPLAY_VIDEO_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleReplayVideo));
  [...rootElement.querySelectorAll(`.${PAUSE_VIDEO_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handlePauseVideo));
  [...rootElement.querySelectorAll(`.${MUTE_VIDEO_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleMuteVideo));
  [...rootElement.querySelectorAll(`.${UNMUTE_VIDEO_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleUnmuteVideo));
  // swipegallery
  [...rootElement.querySelectorAll(`.${SWIPEGALLERY_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, clickEvt, handleControlSwipeGallery));
  // mouseover - show & hide components
  [...rootElement.querySelectorAll(`.${MOUSEOVER_SHOW_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseShowComponent(btn, mouseOverEvt, handleMouseOverShowComponent));
  [...rootElement.querySelectorAll(`.${MOUSEOVER_HIDE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, mouseOverEvt, handleMouseOverHideComponent));
  [...rootElement.querySelectorAll(`.${MOUSEOVER_SHOW_REMOTE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, mouseOverEvt, handleMouseOverShowRemoteComponent));
  [...rootElement.querySelectorAll(`.${MOUSEOVER_HIDE_REMOTE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, mouseOverEvt, handleMouseOverHideRemoteComponent));
  // mouseout - show & hide components
  [...rootElement.querySelectorAll(`.${MOUSEOUT_SHOW_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseShowComponent(btn, mouseOutEvt, handleMouseOutShowComponent));
  [...rootElement.querySelectorAll(`.${MOUSEOUT_HIDE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, mouseOutEvt, handleMouseOutHideComponent));
  [...rootElement.querySelectorAll(`.${MOUSEOUT_SHOW_REMOTE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, mouseOutEvt, handleMouseOutShowRemoteComponent));
  [...rootElement.querySelectorAll(`.${MOUSEOUT_HIDE_REMOTE_COMPONENT_BUTTON_CLASS}`)].forEach(btn => initialiseEvent(btn, mouseOutEvt, handleMouseOutHideRemoteComponent));

  [...getElements(SWIPELEFT_CAROUSEL_GROUP_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftCarousel));
  [...getElements(SWIPELEFT_SWITCH_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftSwitchArtboard));
  [...getElements(SWIPELEFT_SHOW_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftShowComponent));
  [...getElements(SWIPELEFT_HIDE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftHideComponent));
  [...getElements(SWIPELEFT_SHOW_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftShowRemoteComponent));
  [...getElements(SWIPELEFT_HIDE_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftHideRemoteComponent));
  [...getElements(SWIPELEFT_PLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftPlayVideo));
  [...getElements(SWIPELEFT_REPLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftReplayVideo));
  [...getElements(SWIPELEFT_PAUSE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftPauseVideo));
  [...getElements(SWIPELEFT_MUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftMuteVideo));
  [...getElements(SWIPELEFT_UNMUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeLeftUnmuteVideo));

  [...getElements(SWIPERIGHT_CAROUSEL_GROUP_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightCarousel));
  [...getElements(SWIPERIGHT_SWITCH_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeRightSwitchArtboard));
  [...getElements(SWIPERIGHT_SHOW_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightShowComponent));
  [...getElements(SWIPERIGHT_HIDE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightHideComponent));
  [...getElements(SWIPERIGHT_SHOW_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightShowRemoteComponent));
  [...getElements(SWIPERIGHT_HIDE_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightHideRemoteComponent));
  [...getElements(SWIPERIGHT_PLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightPlayVideo));
  [...getElements(SWIPERIGHT_REPLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightReplayVideo));
  [...getElements(SWIPERIGHT_PAUSE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightPauseVideo));
  [...getElements(SWIPERIGHT_MUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightMuteVideo));
  [...getElements(SWIPERIGHT_UNMUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeRightEvt, handleSwipeRightUnmuteVideo));

  [...getElements(SWIPEUP_CAROUSEL_GROUP_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpCarousel));
  [...getElements(SWIPEUP_SWITCH_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeUpSwitchArtboard));
  [...getElements(SWIPEUP_SHOW_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpShowComponent));
  [...getElements(SWIPEUP_HIDE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpHideComponent));
  [...getElements(SWIPEUP_SHOW_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpShowRemoteComponent));
  [...getElements(SWIPEUP_HIDE_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpHideRemoteComponent));
  [...getElements(SWIPEUP_PLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpPlayVideo));
  [...getElements(SWIPEUP_REPLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpReplayVideo));
  [...getElements(SWIPEUP_PAUSE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpPauseVideo));
  [...getElements(SWIPEUP_MUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpMuteVideo));
  [...getElements(SWIPEUP_UNMUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeUpEvt, handleSwipeUpUnmuteVideo));

  [...getElements(SWIPEDOWN_CAROUSEL_GROUP_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownCarousel));
  [...getElements(SWIPEDOWN_SWITCH_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeLeftEvt, handleSwipeDownSwitchArtboard));
  [...getElements(SWIPEDOWN_SHOW_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownShowComponent));
  [...getElements(SWIPEDOWN_HIDE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownHideComponent));
  [...getElements(SWIPEDOWN_SHOW_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownShowRemoteComponent));
  [...getElements(SWIPEDOWN_HIDE_REMOTE_COMPONENT_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownHideRemoteComponent));
  [...getElements(SWIPEDOWN_PLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownPlayVideo));
  [...getElements(SWIPEDOWN_REPLAY_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownReplayVideo));
  [...getElements(SWIPEDOWN_PAUSE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownPauseVideo));
  [...getElements(SWIPEDOWN_MUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownMuteVideo));
  [...getElements(SWIPEDOWN_UNMUTE_VIDEO_BUTTON_CLASS)].forEach(btn => initialiseEvent(btn, swipeDownEvt, handleSwipeDownUnmuteVideo));
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/buttonScript.js